module.exports = __webpack_public_path__ + "img/kakaxi.d62de7ae.png";